'use strict';

const Mn = require('backbone.marionette');
const TagAction = require('system/domain/action/tag');
const TagStore = require('system/domain/repository/tag');
const TagModel = require('system/domain/entity/tag');
const TagListViewTemplate = require('system/ui/template/detail/tag-list.hbs');
const TagItemViewTemplate = require('system/ui/template/detail/tag-item.hbs');
const TagItemEditViewTemplate = require('system/ui/template/detail/tag-item-edit.hbs');

const TagItemView = Mn.View.extend({
    model: TagModel,
    tagName: 'li',
    className: 'tag-list-item-flat',
    template: TagItemViewTemplate,
    events: {
        'click': 'toggle'
    },
    modelEvents: {
        'change': 'render',
        'remove': 'destroy'
    },

    onRender: function() {
        if(this.model.get('deleted')) {
            this.destroy();
            return;
        }
        if(this.model.selected()) {
            this.activate();
        } else {
            this.deactivate();
        }
    },

    activate: function() {
        this.$el.addClass('is-active');
    },

    deactivate: function() {
        this.$el.removeClass('is-active');
    },

    toggle: function() {
        TagAction.toggleTag({
            context: this.getOption('context'),
            tag: {id: this.model.id}
        });
    }
});

const TagItemEditView = TagItemView.extend({
    template: TagItemEditViewTemplate,
    events: {
        'click .remove': '_remove',
        'click': 'toggle'
    },

    _remove: function(evt) {
        this.trigger('remove:tag', this.model);
        this.remove();
        evt.stopPropagation();
    }
});

/**
 * @exports views/diagram/tag-list-view
 */
const TagListView = Mn.CompositeView.extend(
    /**
     * @lends module:views/diagram/tag-list-view.TagListView.prototype
     */
    {
        template: TagListViewTemplate,
        childViewContainer: '.tag-list',
        childViewOptions: function() {
            return {
                context: this._context
            }
        },
        childView: function() {
            if(this.edit) {
                return TagItemEditView;
            } else {
                return TagItemView;
            }
        },

        /**
         * タグを表示するための View。
         *
         * @constructs
         */
        initialize: function(params) {
            this.edit = params.edit;
            this._context = params.context;
            this.listenTo(TagStore.getTags({
                context: this._context
            }), 'change', this.render);
        },

        onChildviewRemoveTag: function(tag) {
            this.trigger('remove:tag', tag);
        }
    });

module.exports = TagListView;



// WEBPACK FOOTER //
// ./system/ui/view/detail/tag-list.js